<template>
	<ui-dialog
		ref="dialog"
		title="User profile"
		closable
	>
		<template v-if="!submitCompleted">
			<ui-input
				v-model="fname"
				readonly
				label="First Name"
			/>
			<ui-input
				v-model="lname"
				readonly
				label="Last Name"
			/>
			<ui-input
				v-model="email"
				readonly
				label="E-mail"
			/>
			<ui-dialog-footer>
				<ui-button
					:disabled="isProcessing"
					primary
					text="Reset password"
					tooltip="Request password reset link by email"
					@click="forgotPassword"
				/>
			</ui-dialog-footer>
		</template>
		<p v-else class="ui-body">
			An email has been sent to you with instructions on how to change your password.<br><br>
			<i>Tip: If you do not receive this email within a reasonable amount of time, please check your spam folder.</i>
		</p>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";
import UiInput from "lib/components/ui/Input";

export default {
	name: "ProfileDialog",
	components: {
		UiButton,
		UiDialog,
		UiDialogFooter,
		UiInput
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			email: this.user.email,
			fname: this.user.fname,
			lname: this.user.lname,
			isProcessing: false,
			submitCompleted: false
		};
	},
	mounted() {
		this.open = () => {
			this.submitCompleted = false;
			this.getUser();
			this.$refs.dialog.open();
		};
	},
	methods: {
		getUser() {
			http.get(`/api/v2/user/${this.user.user_id}`)
			.then((response) => {
				const user = response.data;

				this.fname = user.fname;
				this.lname = user.lname;
				this.email = user.email;
			})
			.catch((error) => {
				alert.error("Unable to get recorder", error.response);
			});
		},
		forgotPassword() {
			this.isProcessing = true;

			http.post("/api/v2/user/forgotpassword", { email: this.email })
			.then(() => {
				this.submitCompleted = true;
			})
			.finally(() => {
				this.isProcessing = false;
			})
			.catch((error) => {
				alert.error("Reset password request failed", error.response);
			});
		}
	}
};
</script>
